/**
 * Created by Administrator on 2018/1/21.
 */

const _import = require("./_import_" + process.env.NODE_ENV);
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

import Layout from "../../views/common/layout/index.vue";
// 路由配置说明
/***
 * meta :{white:底部颜色是否为白色，auth：需要认证的路由地址}
 * 高春超 2018年1月24日00:33:41
 * @type {[*]}
 */
export const constantRouterMap = [
  {
    path: "/",
    component: Layout,
    redirect: "/index",
    name: "首页",
    meta: { title: "首页" },
    children: [
      { path: "index", meta: { title: "首页" }, component: _import("index") },
      {
        path: "enterprise-brand-store",
        name: "企业品牌",
        meta: { title: "企业品牌" },
        component: _import("enterprise-brand-store/index"),
      },
      {
        path: "gold-shop",
        name: "金牌网店",
        meta: { title: "金牌网店" },
        component: _import("gold-shop/index"),
      },
      {
        path: "silver-shop",
        name: "银牌网店",
        meta: { title: "银牌网店" },
        component: _import("silver-shop/index"),
      },
      {
        path: "personal-shop",
        name: "个人网店",
        meta: { title: "个人网店" },
        component: _import("personal-shop/index"),
      },
      {
        path: "common-store",
        component: _import("common-store/index"),
      },
      {
        path: "goods-list",
        name: "商品列表",
        meta: { title: "商品列表" },
        component: _import("goods-godule/goods-list"),
      },
      {
        path: "recommend-goods",
        name: "banner商品列表",
        meta: { title: "banner商品列表" },
        component: _import("goods-godule/recommend-goods"),
      },
      {
        path: "shop-list",
        name: "店铺列表",
        meta: { title: "店铺列表" },
        component: _import("shop/shop-list"),
      },
      {
        path: "same-city-businesses",
        name: "同城商家",
        meta: { title: "同城商家" },
        component: _import("same-city-businesses/index"),
      },
      {
        path: "supply-chain-list",
        name: "直供专区",
        meta: { title: "直供专区" },
        component: _import("goods-godule/goods-list"),
      },
      {
        path: "first-buy-list",
        name: "首购专区",
        meta: { title: "首购专区" },
        component: _import("goods-godule/goods-list"),
      },
      {
        path: "boutique-list",
        name: "直营精品",
        meta: { title: "直营精品" },
        component: _import("goods-boutique/index"),
      },
      {
        path: "paid-information",
        name: "付费资讯",
        meta: { title: "付费资讯" },
        component: _import("paid-information/index"),
      },
      {
        path: "paid-information-title",
        name: "付费资讯",
        meta: { title: "付费资讯" },
        component: _import("paid-information/paid-title"),
      },
    ],
  },
  {
    path: "/leagueAgreement",
    meta: { white: true, title: "联盟商家入驻服务协议" },
    component: _import("league-business/leagueAgreement"),
  },
  {
    path: "/login",
    meta: { white: true, title: "登录" },
    component: _import("login/login"),
  },
  {
    path: "/forget",
    meta: { white: true, title: "联盟商家入驻服务协议" },
    component: _import("forget-password/index"),
  },
  {
    path: "/register",
    meta: { white: true, title: "注册" },
    component: _import("register/index"),
  },
  {
    path: "/shopping-cart",
    meta: { white: true, title: "购物车" },
    component: _import("shopping-cart/index"),
  },
  {
    path: "/pay",
    meta: { screen: true, title: "支付页" },
    component: _import("member-center/right/pay"),
  },
  {
    path: "/weixinPage",
    meta: { screen: true, title: "微信支付页" },
    component: _import("member-center/right/weixinPage"),
  },
  {
    path: "/aliPage",
    meta: { screen: true, title: "支付宝支付页" },
    component: _import("member-center/right/aliPage"),
  },
  {
    path: "/hfwxPage",
    meta: { screen: true, title: "汇付微信支付页" },
    component: _import("member-center/right/huifuweixinPage"),
  },
  {
    path: "/toPay",
    meta: { screen: true, title: "去支付页" },
    component: _import("member-center/right/toPay"),
  },
  {
    path: "/orderdetailForPayment",
    meta: { screen: true },
    component: _import("member-center/right/orderdetailForPayment"),
  },
  {
    path: "/checkout",
    meta: { white: true, isKeepAlive: false, title: "核对信息单" },
    component: _import("shopping-cart/checkout"),
  },
  {
    path: "/payResult",
    meta: { white: true, title: "支付状态-成功" },
    component: _import("shopping-cart/payResult"),
  },
  {
    path: "/deposite",
    meta: { white: true },
    component: _import("member-center/right/deposite"),
  },
  {
    path: "/payError",
    meta: { white: true, title: "支付状态-失败" },
    component: _import("shopping-cart/payError"),
  },
  {
    path: "/help",
    component: Layout,
    children: [
      {
        path: "",
        meta: { isKeepAlive: false, title: "帮助" },
        component: _import("help-center/help"),
      },
    ],
  },
  {
    path: "/goods",
    component: Layout,
    children: [
      {
        path: "",
        meta: { isKeepAlive: false, title: "商品详情" },
        component: _import("goods-godule/good-detail"),
      },
    ],
  },
  {
    path: "/notGood",
    meta: { white: true, title: "商品下架" },
    component: _import("goods-godule/notGood"),
  },
  {
    path: "/businessLeague",
    meta: {
      white: true,
      auth: true,
      isKeepAlive: false,
      title: "联盟商家信息",
    },
    component: _import("league-business/businessLeague"),
  },
  {
    path: "/applyLeague",
    meta: {
      white: true,
      auth: true,
      isKeepAlive: false,
      title: "申请联盟商家",
    },
    component: _import("league-business/applyLeague"),
  },

  {
    path: "/createLeague",
    meta: {
      white: true,
      auth: true,
      isKeepAlive: false,
      title: "申请联盟商家",
    },
    component: _import("league-business/createLeague"),
  },
  {
    path: "/myData",
    name: "会员中心",
    meta: { auth: true },
    component: _import("my-data/index"),
    redirect: "/myData/businessLeague",
    children: [
      {
        path: "businessLeague",
        name: "我的资料",
        meta: { auth: true, title: "我的资料" },
        component: _import("my-data/right/businessLeague"),
      },
      {
        path: "editLeague",
        name: "补充我的资料",
        meta: { auth: true, title: "补充我的资料" },
        component: _import("my-data/right/editLeague"),
      },
      {
        path: "shopImg",
        name: "商品图管理",
        meta: { auth: true, title: "商品图管理" },
        component: _import("my-data/right/uploadShopImg"),
      },
    ],
  },
  {
    path: "/member",
    name: "会员中心",
    meta: { auth: true },
    component: _import("member-center/index"),
    redirect: "/member/member",
    children: [
      {
        path: "member",
        name: "会员中心首页",
        meta: { auth: true, title: "会员中心首页" },
        component: _import("member-center/right/member"),
      },
      {
        path: "order",
        name: "我的订单",
        meta: { auth: true, title: "我的订单" },
        component: _import("member-center/right/order"),
      },
      {
        path: "orderInfo",
        name: "订单详情",
        meta: { auth: true, title: "订单详情" },
        component: _import("member-center/right/orderInfo"),
      },
      {
        path: "returnList",
        name: "退换货",
        meta: { auth: true, title: "退换货" },
        component: _import("member-center/right/returnList"),
      },
      {
        path: "address",
        name: "收货地址",
        meta: { auth: true, title: "收货地址" },
        component: _import("member-center/right/address"),
      },
      {
        path: "favorite",
        name: "我的收藏",
        meta: { auth: true, title: "我的收藏" },
        component: _import("member-center/right/favorite"),
      },
      {
        path: "comments",
        name: "我的评论",
        meta: { auth: true, title: "我的评论" },
        component: _import("member-center/right/comments"),
      },
      {
        path: "myAdvice",
        name: "我的咨询",
        meta: { auth: true, title: "我的咨询" },
        component: _import("member-center/right/myAdvice"),
      },
      {
        path: "personalProfile",
        name: "完善基本资料",
        meta: { auth: true, title: "完善基本资料" },
        component: _import("member-center/right/personalProfile"),
      },
      // {
      //   path: "myShoppingScore",
      //   name: "购物积分获取记录",
      //   meta: { auth: true },
      //   component: _import("member-center/right/myShoppingScore"),
      // },
      // {
      //   path: "myGrowth",
      //   name: "我的成长值",
      //   meta: { auth: true },
      //   component: _import("member-center/right/myGrowth"),
      // },
      {
        path: "shoppingScore",
        name: "我的积分",
        meta: { auth: true, title: "我的积分" },
        component: _import("member-center/right/shoppingScore"),
      },
      {
        path: "point",
        name: "我的积分",
        meta: { auth: true, title: "我的积分" },
        component: _import("member-center/right/point"),
      },
      {
        path: "myRecommend",
        name: "我推荐的免费会员",
        meta: { auth: true, title: "我推荐的免费会员" },
        component: _import("member-center/right/myRecommend"),
      },
      {
        path: "security",
        name: "修改密码",
        meta: { auth: true, title: "修改密码" },
        component: _import("member-center/right/security"),
      },
      {
        path: "payPassWord",
        name: "修改支付密码",
        meta: { auth: true, title: "修改支付密码" },
        component: _import("member-center/right/payPassWord"),
      },
      {
        path: "bankCard",
        name: "我的银行卡",
        meta: { auth: true },
        component: _import("member-center/right/bankCard"),
      },
      {
        path: "myCoupons",
        name: "我的优惠券",
        meta: { auth: true, title: "我的优惠券" },
        component: _import("member-center/right/myCoupons"),
      },
    ],
  },
  {
    path: "/shop",
    meta: { white: true, title: "店铺详情" },
    component: _import("shop/shop-detail"),
  },
  {
    path: "/china-time-honored",
    name: "中华老字号",
    meta: { white: true, title: "中华老字号" },
    component: _import("china-time-honored/index"),
  },
  {
    path: "/fresh-agricultural",
    name: "农特生鲜",
    meta: { white: true, title: "农特生鲜" },
    component: _import("fresh-agricultural/index"),
    redirect: "/fresh-agricultural/3",
    children: [
      {
        path: ":cat_id",
        name: "农特生鲜内容",
        meta: { title: "农特生鲜" },
        component: _import("fresh-agricultural/content-item"),
      },
    ],
  },
  {
    path: "/self-owned-mall",
    name: "自营商城",
    meta: { white: true, title: "自营商城" },
    component: _import("self-owned-mall/index/index"),
  },
  {
    path: "/lucky-draw",
    name: "我的抽奖",
    meta: { white: true, title: "我的抽奖" },
    component: _import("lucky-draw/lucky-draw"),
  },
  {
    path: "/landmark-superior-product",
    name: "中国地标优品",
    meta: { white: true, title: "中国地标优品" },
    component: _import("landmark-superior-product/index"),
  },
  {
    path: "/landmark-goods-list",
    name: "地标优品商品列表",
    meta: { white: true, isKeepAlive: false, title: "地标优品商品列表" },
    component: _import("landmark-goods-list/index"),
  },
  {
    path: "/goods-boutique",
    name: "直营精品",
    meta: { white: true, title: "直营精品" },
    component: _import("goods-boutique/index"),
  },
  {
    path: "/activity",
    name: "活动页",
    meta: { white: true, title: "活动页" },
    component: _import("activity/index"),
  },
  {
    path: "/account-center",
    name: "我的账户",
    meta: { auth: true, isKeepAlive: false, title: "我的账户" },
    component: _import("account-center/index"),
  },
  {
    path: "/showTransfer",
    name: "积分转换",
    meta: { auth: true, isKeepAlive: false, title: "积分转换" },
    component: _import("account-center/showTransfer"),
  },
  {
    path: "/showAlipay",
    name: "充值",
    meta: { auth: true, isKeepAlive: false, title: "充值" },
    component: _import("account-center/showAlipay"),
  },
  {
    path: "/showConsumeConfirm",
    name: "查看期权",
    meta: { auth: true, isKeepAlive: false, title: "查看期权" },
    component: _import("account-center/showConsumeConfirm"),
  },
  {
    path: "/showMyAccount",
    name: "消费期权优先股",
    meta: { auth: true, isKeepAlive: false, title: "消费期权优先股" },
    component: _import("account-center/showMyAccount"),
  },
  {
    path: "/bonusCash",
    name: "奖金积分提现",
    meta: { auth: true, isKeepAlive: false, title: "奖金积分提现" },
    component: _import("account-center/bonusCash"),
  },
  {
    path: "/netStoreCash",
    name: "商家余额提现",
    meta: { auth: true, isKeepAlive: false, title: "商家余额提现" },
    component: _import("account-center/netStoreCash"),
  },
  {
    path: "/point-item",
    name: "积分明细",
    meta: { auth: true, isKeepAlive: false, title: "积分明细" },
    component: _import("account-center/pointItem"),
  },
  {
    path: "*",
    meta: { white: true },
    component: _import("common/404"),
  },
];

const router = new Router({
  mode: "history", // 后端支持可开
  scrollBehavior: () => ({ y: 0 }), // 当转到一个新的页面时，定位到最顶端。
  routes: constantRouterMap,
});

export default router;



// WEBPACK FOOTER //
// ./src/components/router/index.js